import jwtDecode from 'jwt-decode';
import router from "@/router";
import {
  FETCH_NUMBERS,
  FETCH_HISTORY,
  FIND_NUMBER,
  LOGIN_STEP1_SUBMIT_NUMBER,
  LOGIN_STEP2_SUBMIT_VERIFICATION_CODE,
  LOGOUT,
  SET_TOKENS,
  GET_STATUS,
  MAKE_A_CALL,
  HANG_UP_A_CALL,
  SEARCH_BRIDGE_BY_NUMBER,
  GET_ALL_BRIDGES,
  GET_USER_HISTORY,
  FETCH_DOMAIN_USERS,
  DELETE_DOMAIN_USER,
  SAVE_DOMAIN_USER,
  UPDATE_FEED_DESCRIPTION,
  GET_BRIDGE_BY_FEED_NUMBER,
  GET_STATUS_WITH_FEED_NUMBER,
  SET_IS_POLLING_STATUS,
  SET_API_ERROR_ACTION,
  HANG_UP_BRIDGE,
  CLEAN_UP_SEARCH_RES,
  RE_DIAL,
} from '../action-types';

import {
  SET_LOADING,
  SET_NUMBERS,
  SET_HISTORY,
  SET_SEARCH_NUMBER,
  SET_VERIFY_NUMBER_ID,
  SET_VERIFY_NUMBER_ERR,
  SET_AUTH,
  SET_AUTH_ERR,
  CLEAN_UP_AUTH,
  SET_STATUS,
  SET_IN_CONVERSATION,
  SET_USER_ACTIVE_CALL,
  SET_USER_LOGIN_NUMBER,
  SET_SEARCH_NUMBER_ERR,
  SET_ALL_BRIDGES,
  SET_PROFILE_NAME,
  SET_DOMAIN_USERS,
  SET_SEARCHED_BRIDGE,
  SET_POLLING_STATUS,
  SET_API_ERROR,
  SET_ADMIN_LAYOUT,
  SET_BRIDGE_ERROR,
  CLEANUP_SEARCH_DATA,
} from '../mutation-types';

import {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  NUMBER_KEY,
  IS_ADMIN,
  PROFILE_NAME_KEY,
} from "Constants/settings";
import {
  ROLES,
  USER_HISTORY_LIMIT,
  CALL_STATUSES,
  ERROR_CODES,
} from "Constants/nciConstants";

import { auth, rest } from 'Api/nci_api';

export default {
  // namespaced: true,
  state: {
    loading: false,
    // loginNumber: '+359878602432', // TODO REMOVE AFTER TEST
    loginNumber: '',
    loginNumberSuccessful: false,
    loginCode: '',
    profileName: '',
    loginCodeSuccessful: false,
    verifyNumberId: '',
    verifyNumberErr: '',
    accessToken: '',
    refreshToken: '',
    authErr: '',
    isLoggedIn: false,
    isAdmin: false,
    // isAdmin: true, // TODO REMOVE AFTER TEST
    numbers: [],
    history: [],
    searchNumber: null,
    searchNumberErr: '',
    userStatus: false,
    inConversation: false,
    userActiveCall: null,
    bridges: [],
    domainUsers: [],
    searchedBridge: null,
    isPollingStatus: false,
    apiError: null,
    isAdminLayout: false,
    bridgeError: null,
  },

  mutations: {
    [SET_LOADING](state, loading) {
      state.loading = loading;
    },
    [SET_NUMBERS](state, numbers) {
      state.numbers = numbers;
    },
    [SET_HISTORY](state, history) {
      state.history = history;
    },
    [SET_SEARCH_NUMBER](state, searchNumber) {
      state.searchNumber = searchNumber;
    },
    [SET_VERIFY_NUMBER_ID](state, verify_id) {
      state.verifyNumberId = verify_id;
    },
    [SET_VERIFY_NUMBER_ERR](state, verifyErr) {
      state.verifyNumberErr = verifyErr;
    },
    [SET_SEARCH_NUMBER_ERR](state, err) {
      state.searchNumberErr = {...err};
    },
    [SET_AUTH](state, auth) {
      if (!auth) {
        state.isLoggedIn = false;
        if (state.loginNumber) {
          localStorage.setItem(NUMBER_KEY, state.loginNumber);
        }
      } else {
        state.accessToken = auth['access_token'];
        state.refreshToken = auth['refresh_token'];

        localStorage.setItem(ACCESS_TOKEN_KEY, auth['access_token']);
        localStorage.setItem(REFRESH_TOKEN_KEY, auth['refresh_token']);

        const decodedJwt = jwtDecode(state.accessToken);
        // console.log('decodedJwt: ',decodedJwt);
        const isAdmin = decodedJwt.role === ROLES.SUPERVISOR;
        state.profileName = decodedJwt['caller_name'] || auth['caller_name'] || auth['profileName'] || '';
        if(isAdmin) {
          localStorage.setItem(IS_ADMIN, isAdmin);
        }
        if(auth['number']) {
          state.loginNumber = auth['number'];
          localStorage.setItem(NUMBER_KEY, state.loginNumber);
        } else if (state.loginNumber) {
          localStorage.setItem(NUMBER_KEY, state.loginNumber);
        }
        if(state.profileName) {
          localStorage.setItem(PROFILE_NAME_KEY, state.profileName);
        }

        state.verifyNumberId = '';
        state.isLoggedIn = true;
        state.isAdmin = !!isAdmin;
      }
    },
    [SET_AUTH_ERR](state, verifyErr) {
      state.authErr = verifyErr;
    },
    [CLEAN_UP_AUTH](state) {
      state.isLoggedIn = false;
      state.accessToken = '';
      state.refreshToken = '';
      state.isAdmin = false;
      // state.loginNumber = '';
      state.profileName = '';
      state.searchedBridge = null;
      state.searchNumberErr = '';
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      localStorage.removeItem(IS_ADMIN);
      localStorage.removeItem(NUMBER_KEY);
      localStorage.removeItem(PROFILE_NAME_KEY);
    },
    [SET_STATUS](state, status) {
      state.userStatus = status;
    },
    [SET_IN_CONVERSATION](state, status) {
      state.inConversation = status;
    },
    [SET_USER_ACTIVE_CALL](state, activeCall) {
      state.userActiveCall = activeCall;
    },
    [SET_USER_LOGIN_NUMBER](state, number) {
      state.loginNumber = number;
    },
    [SET_ALL_BRIDGES](state, bridges) {
      state.bridges = bridges;
    },
    [SET_PROFILE_NAME](state, name) {
      state.profileName = name;
    },
    [SET_DOMAIN_USERS](state, users) {
      state.domainUsers = users;
    },
    [SET_SEARCHED_BRIDGE](state, bridge) {
      state.searchedBridge = { ...bridge };
    },
    [SET_POLLING_STATUS](state, polling) {
      state.isPollingStatus = polling;
    },
    [SET_API_ERROR](state, errorObject) {
      state.apiError = errorObject;
    },
    [SET_ADMIN_LAYOUT](state, isAdmin) {
      state.isAdminLayout = isAdmin;
    },
    [SET_BRIDGE_ERROR](state, msg) {
      state.bridgeError = msg;
    },
    [CLEANUP_SEARCH_DATA](state) {
      state.searchedBridge = null;
      state.searchNumberErr = null;
      state.searchNumber = null;

    },

  },

  getters: {
    isLoggedIn(state /* getters, rootState */) {
      let isL = false;
      if (localStorage.getItem(ACCESS_TOKEN_KEY) && localStorage.getItem(REFRESH_TOKEN_KEY)) {
        isL = true;
      }
      return state.isLoggedIn;
    },
    isAdmin(state /* getters, rootState */) {
      return state.isAdmin;
    },
    getNumbers(state) {
      return state.numbers;
    },
    getHistory(state) {
      return state.history;
    },
    getSearchNumber(state) {
      return state.searchNumber;
    },
    getVerifyNumberId(state) {
      return state.verifyNumberId;
    },
    getVerifyNumberErr(state) {
      return state.verifyNumberErr;
    },
    getSearchNumberErr(state) {
      return state.searchNumberErr;
    },
    getLoading(state) {
      return state.loading;
    },
    getUserStatus(state) {
      return state.userStatus;
    },
    getInConversation(state) {
      return state.inConversation;
    },
    getUserActiveCall(state) {
      // const activeCall = state.numbers.find((el) => {
      //   return el.active;
      // })
      return state.userActiveCall;
    },
    getUserLoginNumber(state) {
      return state.loginNumber;
    },
    getAllBridges(state) {
      return state.bridges;
    },
    getProfileName(state) {
      return state.profileName;
    },
    getDomainUsers(state) {
      return state.domainUsers;
    },
    getSearchedBridge(state) {
      return state.searchedBridge;
    },
    getIsPollingStatus(state) {
      return state.isPollingStatus;
    },
    getApiError(state) {
      return state.apiError;
    },
    getIsAdminLayout(state) {
      return state.isAdminLayout;
    },
    getBridgeError(state) {
      return state.bridgeError;
    },


  },

  actions: {
    async [LOGIN_STEP1_SUBMIT_NUMBER]({ commit }, number) {
      commit(SET_LOADING, true);
      try {
        const verifyNumberResponse = await auth.verifyNumber(number);
        if (verifyNumberResponse && verifyNumberResponse['verify_id']) {
          commit(SET_USER_LOGIN_NUMBER, number);
          localStorage.setItem(NUMBER_KEY, number);
          commit(SET_VERIFY_NUMBER_ID, verifyNumberResponse['verify_id']);
          commit(SET_API_ERROR, null);
        } else {
          let err = '';
          if (verifyNumberResponse && verifyNumberResponse['error_description'] && verifyNumberResponse['error_code']) {
            commit(SET_API_ERROR, {code: verifyNumberResponse['error_code']});
          } else {
            err = 'Wrong number';
          }
          commit(SET_VERIFY_NUMBER_ERR, err);
        }
        commit(SET_LOADING, false);
      } catch (err) {
        commit(SET_VERIFY_NUMBER_ERR, err);
        console.error('ERROR VERIFY NUMBER: ', err);
        commit(SET_LOADING, false);
      }
    },
    async [LOGIN_STEP2_SUBMIT_VERIFICATION_CODE]({ commit, state }, code) {
      commit(SET_LOADING, true);
      try {
        const verifyCodeResponse = await auth.verifyCode(code, state.verifyNumberId);
        // console.log('verify code login step 2 response: ', verifyCodeResponse);
        if (verifyCodeResponse && verifyCodeResponse['access_token'] && verifyCodeResponse['refresh_token']) {
          commit(SET_API_ERROR, null);
          commit(SET_AUTH, verifyCodeResponse);
        } else if (verifyCodeResponse && verifyCodeResponse['error_description'] && verifyCodeResponse['error_code']) {
          commit(SET_API_ERROR, {code: verifyCodeResponse['error_code']});
        } else {
          commit(SET_VERIFY_NUMBER_ERR, 'Wrong code');
        }
        commit(SET_LOADING, false);
      } catch (err) {
        commit(SET_VERIFY_NUMBER_ERR, err);
        console.error('ERROR VERIFY CODE: ', err);
        if (err && err['error_description'] && err['error_code']) {
          commit(SET_API_ERROR, {code: err['error_code']});
        }
        commit(SET_LOADING, false);
      }
    },
    async [LOGOUT]({ commit }) {
      commit(SET_LOADING, true);
      try {
        const aToken = localStorage.getItem(ACCESS_TOKEN_KEY);
        const rToken = localStorage.getItem(REFRESH_TOKEN_KEY);
        await auth.logout(aToken, rToken);
        commit(CLEAN_UP_AUTH);
        commit(SET_LOADING, false);
      } catch (e) {
        console.error('ERROR LOGOUT: ', e);
        commit(SET_LOADING, false);
      }

    },
    async [SET_TOKENS]({ commit }) {
      const aToken = localStorage.getItem(ACCESS_TOKEN_KEY);
      const rToken = localStorage.getItem(REFRESH_TOKEN_KEY);
      const number = localStorage.getItem(NUMBER_KEY);
      const profileName = localStorage.getItem(PROFILE_NAME_KEY);

      let auth = null;
      if (aToken && rToken) {
        auth = {access_token: aToken, refresh_token: rToken, number, profileName };
      }
      commit(SET_AUTH, auth);
    },
    async[GET_STATUS]({ commit, state, dispatch  }, feedNumber) {
      try {
        let status = false;
        let inConv = false;
        let statusRes = null;
        if (feedNumber) {
          statusRes = await rest.getBridgeByFeedNumber(feedNumber);
        } else {
          statusRes = await rest.getUserStatus();
        }

        if (statusRes) {
          const latestCall = statusRes.call;
          const feed = statusRes.feed;

          if (latestCall && latestCall.state !== CALL_STATUSES.COMPLETED) {
            status = true;
            inConv = true;
            commit(SET_USER_ACTIVE_CALL, statusRes);
          }
          else if (statusRes && feed && !statusRes.bridge && !latestCall) {
            status = false;
            inConv = false;
            commit(SET_USER_ACTIVE_CALL, null);
            commit(SET_SEARCHED_BRIDGE, null);
            commit(SET_SEARCH_NUMBER_ERR, feed);
          }
          else if (statusRes && Object.keys(statusRes).length === 0) {
            status = false;
            inConv = false;
            commit(SET_USER_ACTIVE_CALL, null);
          } else if (statusRes && statusRes.bridge && !latestCall) {
            status = false;
            inConv = false;
            commit(SET_USER_ACTIVE_CALL, null);
            commit(SET_SEARCHED_BRIDGE, statusRes);
          }
        }
        commit(SET_STATUS, status);
        commit(SET_IN_CONVERSATION, inConv);
      } catch (e) {
        console.error('ERROR GET STATUS: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        } else if (e['error_code'] && (e['error_code']=== ERROR_CODES.UNKNOWN_TOKEN_PAIR)) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
        // commit(SET_LOADING, false);
      }

    },
    async[GET_USER_HISTORY]({ commit, state, dispatch }, limit) {
      const lim = limit || USER_HISTORY_LIMIT;
      try {
        commit(SET_LOADING, true);
        const latestCalls = await rest.getLatestCalls(lim, state.loginNumber);
        if (latestCalls.list && latestCalls.list.length) {
          commit(SET_HISTORY, latestCalls.list);
        }
        commit(SET_LOADING, false);
      } catch (e) {
        console.error('ERROR GET_USER_HISTORY: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED)
            || (e['error_category'] && e['error_category'] === ERROR_CODES.OTHER) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
        commit(SET_LOADING, false);
      }

    },
    async[MAKE_A_CALL]({ commit, state, dispatch }, feedNumber) {
      try {
        commit(SET_POLLING_STATUS, false);
        commit(SET_LOADING, true);
        const makeACallRes = await rest.makeACall(feedNumber, state.loginNumber);
        if (makeACallRes && makeACallRes['callId']) {
          console.log('Make a call result: ', makeACallRes);
          console.log('Make a call get status with feed number: ', feedNumber);
          await dispatch(GET_STATUS, feedNumber);
        }
        commit(SET_POLLING_STATUS, true);
        commit(SET_LOADING, false);
      } catch (e) {
        console.error('ERROR MAKE_A_CALL: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
        commit(SET_LOADING, false);
      }
    },
    async[HANG_UP_A_CALL]({ commit, state, dispatch }, callId) {
      commit(SET_POLLING_STATUS, false);
      try {
        commit(SET_LOADING, true);
        const hangUpACallRes = await rest.hangUpACall(callId, state.loginNumber);
        if (hangUpACallRes) {
          // console.log('Hang up a call result: ', hangUpACallRes);
        }
        let feedNum = null;
        if (state.searchedBridge && state.searchedBridge.bridge && state.searchedBridge.bridge.feedNumber) {
          feedNum = state.searchedBridge.bridge.feedNumber;
        } else if (state.searchNumberErr && state.searchNumberErr.number) {
          feedNum = state.searchNumberErr.number;
        }
       await dispatch(GET_STATUS, feedNum);
        commit(SET_LOADING, false);
        commit(SET_POLLING_STATUS, true);
      } catch (e) {
        console.error('ERROR HANG_UP_A_CALL: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        } else {
         await dispatch(GET_STATUS);
          commit(SET_LOADING, false);
          commit(SET_POLLING_STATUS, true);
        }
      }
    },
    async[SEARCH_BRIDGE_BY_NUMBER]({ commit, state, dispatch }, { feedNumber, autoJoin }) {
      let searchNumber = null;
      try {
        commit(SET_SEARCH_NUMBER_ERR, '');
        commit(SET_SEARCH_NUMBER, null);
        const searchBridgeByNumberRes = await rest.searchBridgeByNumber(feedNumber);
        if (searchBridgeByNumberRes) {
          if (searchBridgeByNumberRes['error_description']) {
            commit(SET_SEARCH_NUMBER_ERR, searchBridgeByNumberRes['error_description']);
          } else {
            searchNumber = searchBridgeByNumberRes;
          }
          if (autoJoin) {
            await dispatch(MAKE_A_CALL, feedNumber);
          } else {
            commit(SET_LOADING, false);
          }
          commit(SET_SEARCH_NUMBER, searchNumber);

        } else {
          commit(SET_LOADING, false);
        }

      } catch (e) {
        console.error('ERROR SEARCH_BRIDGE_BY_NUMBER: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
      }
    },
    async[GET_ALL_BRIDGES]({ commit, state, dispatch }) {
      try {
        commit(SET_LOADING, true);
        const getAllBridgesRes = await rest.getAllBridges();
        if (getAllBridgesRes && getAllBridgesRes.list ) {
          commit(SET_ALL_BRIDGES, getAllBridgesRes.list);
        }
        commit(SET_LOADING, false);
      } catch (e) {
        console.error('ERROR GET_ALL_BRIDGES: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
      }
    },
    async[FETCH_DOMAIN_USERS]({ commit, state, dispatch }) {
      try {
        commit(SET_LOADING, true);
        const allDomainUsers = await rest.getDomainUsers();
        if (allDomainUsers && allDomainUsers.length ) {
          commit(SET_DOMAIN_USERS, allDomainUsers);
        }
        commit(SET_LOADING, false);
      } catch (e) {
        console.error('ERROR FETCH_DOMAIN_USERS: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
      }
    },
    async[SAVE_DOMAIN_USER]({ commit, state, dispatch }, {edit, user}) {
      try {
        commit(SET_LOADING, true);
        const savedUser = await rest.saveUser({edit, user});
        if (savedUser) {
          console.log('Saved domain user result: ', savedUser);
          // commit(SET_DOMAIN_USERS, allDomainUsers);
        }
        commit(SET_LOADING, false);
      } catch (e) {
        console.error('ERROR SAVE_DOMAIN_USER: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
      }
    },
    async[DELETE_DOMAIN_USER]({ commit, state, dispatch }, {user}) {
      try {
        commit(SET_LOADING, true);
        const savedUser = await rest.deleteUser(user.phone);
        if (savedUser) {
          console.log('Saved domain user result: ', savedUser);
          // commit(SET_DOMAIN_USERS, allDomainUsers);
        }
        commit(SET_LOADING, false);
      } catch (e) {
        console.error('ERROR DELETE_DOMAIN_USER: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
      }
    },
    async[UPDATE_FEED_DESCRIPTION]({ commit, state, dispatch }, {description, feedNumber}) {
      try {
        commit(SET_LOADING, true);
        const updatedFeedDescription = await rest.updateFeedDescription(feedNumber, {description});
        commit(SET_LOADING, false);
      } catch (e) {
        console.error('ERROR UPDATE_FEED_DESCRIPTION: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
      }
    },
    async[GET_BRIDGE_BY_FEED_NUMBER]({ commit, state, dispatch }, { userNumber, feedNumber, autoJoin }) {
      let searchedBridge = null;
      try {
        commit(SET_SEARCH_NUMBER_ERR, '');
        commit(SET_SEARCH_NUMBER, null);
        commit(SET_POLLING_STATUS, false);

        const searchedBridgeByNumberRes = await rest.getBridgeByFeedNumber(feedNumber);
        if (searchedBridgeByNumberRes) {
          if (searchedBridgeByNumberRes['error_description'] ) {
            commit(SET_SEARCH_NUMBER_ERR, searchedBridgeByNumberRes['error_description']);
          } else if(searchedBridgeByNumberRes.feed) {
            commit(SET_SEARCHED_BRIDGE, searchedBridge);
            commit(SET_SEARCH_NUMBER_ERR, searchedBridgeByNumberRes.feed);
            commit(SET_POLLING_STATUS, true);
          } else {
            searchedBridge = searchedBridgeByNumberRes;
            // console.log('SET SEARCHED BRIDGE')
            commit(SET_POLLING_STATUS, true);
            commit(SET_SEARCHED_BRIDGE, searchedBridge);
            if (autoJoin) {
             await dispatch(MAKE_A_CALL, feedNumber);
            }
          }
          // commit(SET_SEARCH_NUMBER, searchNumber);
          commit(SET_LOADING, false);

        } else {
          commit(SET_SEARCHED_BRIDGE, searchedBridge);
          commit(SET_LOADING, false);
        }

      } catch (e) {
        console.error('ERROR SEARCH_BRIDGE_BY_NUMBER: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
      }
    },
    async[SET_IS_POLLING_STATUS]({ commit, state, dispatch }, polling) {
      commit(SET_POLLING_STATUS, polling);
    },
    async[SET_API_ERROR_ACTION]({ commit, state, dispatch }, error) {
      commit(SET_API_ERROR, error);
    },
    async[HANG_UP_BRIDGE]({ commit, state, dispatch }, {feedNumber, generation, version, status}) {
      commit(SET_LOADING, true);
      let terminatedBridge = null;
      try {
        terminatedBridge = await rest.hangUpABridge(feedNumber, {generation, version, state: status});
        if (terminatedBridge) {
          console.log('TERMINATE BRIDGE RES: ', terminatedBridge)
          if (terminatedBridge && terminatedBridge['error_description'] && terminatedBridge['error_description']==='Bridge changed') {
            commit(SET_BRIDGE_ERROR, {message: 'Bridge changed, please reload to review the bridge.'});
          } else {
            await dispatch(GET_ALL_BRIDGES);
          }
        }
        commit(SET_LOADING, false);

      } catch (e) {
        console.error('ERROR HANG_UP_BRIDGE: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        }
      }
    },

    async[CLEAN_UP_SEARCH_RES]({ commit, state, dispatch }) {
      commit(SET_LOADING, true);
      commit(CLEANUP_SEARCH_DATA);
      commit(SET_LOADING, false);
    },

    async[RE_DIAL]({ commit, state, dispatch }) {
      commit(SET_POLLING_STATUS, false);
      try {
        const { feedNumber, generation, version } = state.userActiveCall.bridge;
        const status = CALL_STATUSES.DIALING;
        const redialRes = await rest.hangUpABridge(feedNumber, {generation, version, state: status});
        // console.log('Re-dial result: ', redialRes);

        let feedNum = null;
        if (state.searchedBridge && state.searchedBridge.bridge && state.searchedBridge.bridge.feedNumber) {
          feedNum = state.searchedBridge.bridge.feedNumber;
        } else if (state.searchNumberErr && state.searchNumberErr.number) {
          feedNum = state.searchNumberErr.number;
        }
        await dispatch(GET_STATUS, feedNum);
        commit(SET_POLLING_STATUS, true);
      } catch (e) {
        console.error('ERROR RE_DIAL: ',e);
        if (e['error_code'] && (e['error_code']=== ERROR_CODES.EXPIRED_REFRESH_TOKEN || e['error_code'] === ERROR_CODES.JWT_NOT_VERIFIED) ) {
          commit(CLEAN_UP_AUTH);
          commit(SET_POLLING_STATUS, false);
          commit(SET_API_ERROR, {code: ERROR_CODES.EXPIRED_REFRESH_TOKEN});
          commit(SET_LOADING, false);
          router.push({name: 'login'});
        } else {
          await dispatch(GET_STATUS);
          commit(SET_LOADING, false);
          commit(SET_POLLING_STATUS, true);
        }
      }
    },
  },

};
